import { Switch } from "@/shared/components/primitives/switch";

interface ColocaSwitchProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  size?: "sm" | "default";
  "aria-label"?: string;
}

export function ColocaSwitch({
  checked,
  onCheckedChange,
  disabled,
  size = "default",
  ...props
}: ColocaSwitchProps) {
  return (
    <Switch checked={checked} onCheckedChange={onCheckedChange} disabled={disabled} size={size} {...props} />
  );
}
